
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';

interface BulletinBackButtonProps {
  onClose: () => void;
}

const BulletinBackButton = ({ onClose }: BulletinBackButtonProps) => {
  const isMobile = useIsMobile();
  
  return (
    <motion.button
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`${isMobile ? 'bg-black/50 p-3 rounded-full backdrop-blur-sm' : 'bg-transparent p-2'} text-white hover:text-white flex items-center gap-2 transition-colors`}
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
      style={{ zIndex: 70 }} // Ensure button is above all other elements
    >
      <ArrowLeft className="w-5 h-5" />
      {!isMobile && <span className="text-sm">Back</span>}
    </motion.button>
  );
};

export default BulletinBackButton;
